import type { ExportFormat } from '../types';

export function slugifyExportTitle(title: string): string {
  return title
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/['’]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || 'project';
}

export function exportDownloadDetails(title: string, format: ExportFormat): {
  contentType: string;
  filename: string;
} {
  const slug = slugifyExportTitle(title);
  switch (format) {
    case 'markdown':
      return { contentType: 'text/markdown; charset=utf-8', filename: `${slug}-paper-edit.md` };
    case 'html':
      return { contentType: 'text/html; charset=utf-8', filename: `${slug}-paper-edit.html` };
    case 'csv':
      return { contentType: 'text/csv; charset=utf-8', filename: `${slug}-export.csv` };
    case 'resolve_csv':
      return { contentType: 'application/x-cmx3600-edl; charset=utf-8', filename: `${slug}-markers.edl` };
    case 'srt':
      return { contentType: 'application/x-subrip; charset=utf-8', filename: `${slug}-decisions.srt` };
  }
}
